export const VERSION_SHA = 'bd09c16fedca69586029996763cfc322e1d2cf1f';
